const TEXT = Object.freeze({
    IF_WINNER: 'Введите свой номер телефона, чтобы проверить, стали ли вы счастливым обладателем приза',
    IS_WINNER: 'Вы стали победителем. Введите код из СМС, заполняйте анкету и забирайте приз!',
    NOT_A_WINNER: 'К сожалению, сегодня вы не выиграли приз. Мы ждём вас снова. В следующий раз вам обязательно повезёт!',
})

export {
    TEXT,
}